import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { courses, TeachingAffiliation } from "@/features/teaching/catalog";
import { headingText } from "@/lib/heading";

export function TeachingPage() {
  return (
    <>
      <Seo
        title="Teaching"
        description="Teaching Associate at Henley Business School and Stellenbosch University. Courses on AI, the new world of work, and AI and behavior."
        path="/teaching"
      />
      <section className="wrap section" style={{ paddingTop: "4.5rem" }}>
        <p className="eyebrow">Teaching</p>
        <h1>The same argument, in the classroom</h1>
        <p className="lede">
          <TeachingAffiliation />
        </p>
        <p>
          I teach computational social science, network analysis, platform
          architecture, and prediction in production.
        </p>
      </section>
      <section className="wrap grid-3">
        {courses.map((course) => (
          <article className="card" key={course.slug} id={course.slug}>
            <h2>{headingText(course.title)}</h2>
            <p>{course.argument}</p>
            <p>
              {course.readings.map((reading, index) => (
                <span key={reading.to}>
                  {index > 0 ? " · " : null}
                  <Link to={reading.to}>{reading.label}</Link>
                </span>
              ))}
            </p>
          </article>
        ))}
      </section>
      <section className="wrap section">
        <p>
          Other sessions sit in those same four competencies.{" "}
          <Link to="/about">About</Link>
          {" · "}
          <Link to="/work-with-jay">Workshops</Link>
        </p>
      </section>
    </>
  );
}
